import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'

import logoImg from '../../assets/images/logo.png';
import landingImg from '../../assets/images/landing.svg';

import cardIcon from '../../assets/images/icons/card.svg';

import api from '../../services/api';

import './styles.css';

function Landing() {
  const [totalConnections, setTotalConnections] = useState(0);


  useEffect(() => {
    api.get('connections').then(response => {
      const { total } = response.data; 

      setTotalConnections(total);
    })
  }, []);

  return (
    <div id="page-landing">
      <div id="page-landing-content" className="container">
        <div className="logo-container">
          <img src={logoImg} alt="MMSP" className="logo" />
        </div>

      {/*   <img 
          src={hello} 
          alt="carteirinha" 
          className="hero-image"
        /> */}

        <div className="buttons-container">
    
          <Link to="/carteira" className="give-classes">
            <img src={cardIcon} alt="Avaliar"/>
            Carteira do Artesão
          </Link>
        </div>
{/* 
        <span className="total-connections">
          Total de {totalConnections} conexões já realizadas <img src={purpleHeartIcon} alt="Coração roxo" />
        </span> */}
       
      </div>
     {/*  <p style={{textAlign:'center'}}>&copy; Rede Asta</p> */}
    </div>
  )
}

export default Landing;